import CornerBrackets from "./CornerBrackets";

const IdFrame = ({ isOk, side }) => {
  const c = isOk ? "rgba(96,165,250,0.7)" : "rgba(255,255,255,0.35)";
  const cs = isOk ? "rgba(96,165,250,0.9)" : "rgba(255,255,255,0.6)";

  const guideContent = side === "BACK" ? (
    <>
      <rect x="10" y="12" width="245" height="22" rx="4" fill={c} />
      <rect x="10" y="42" width="75" height="22" rx="4" fill={c} />
      <rect x="93" y="48" width="50" height="10" rx="3" fill={c} />
      <rect x="184" y="48" width="71" height="10" rx="3" fill={c} />
      <rect x="10" y="110" width="245" height="5" rx="2.5" fill={c} />
      <rect x="10" y="122" width="245" height="5" rx="2.5" fill={c} />
      <rect x="10" y="134" width="115" height="5" rx="2.5" fill={c} />
    </>
  ) : (
    <>
      <circle cx="53" cy="57" r="29" stroke={cs} strokeWidth="3" fill="none" />
      <circle cx="53" cy="50" r="9" fill={c} />
      <path d="M30 79C35 66 71 66 76 79" stroke={cs} strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <rect x="100" y="30" width="145" height="18" rx="3" fill={c} />
      <rect x="100" y="56" width="90" height="8" rx="3" fill={c} />
      <rect x="198" y="56" width="47" height="8" rx="3" fill={c} />
      <rect x="101" y="72" width="144" height="5" rx="2.5" fill={c} />
      <rect x="10" y="98" width="245" height="5" rx="2.5" fill={c} />
      <rect x="10" y="110" width="245" height="5" rx="2.5" fill={c} />
      <rect x="10" y="122" width="245" height="5" rx="2.5" fill={c} />
      <rect x="10" y="134" width="150" height="5" rx="2.5" fill={c} />
    </>
  );

  return (
    <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
      <div
        className="relative"
        style={{
          width: "98%",
          // Real ID-1 card ratio (85.6mm x 54mm) — matches
          // getOverlayForDocumentType's DEFAULT spec in DocumentCamera.jsx.
          // A fixed h-[45%]/h-[38%] here previously drifted from whatever
          // that math assumed on any screen whose aspect ratio didn't match
          // the one device it was tuned against; aspectRatio, like the
          // other three frame components already use, stays correct on any
          // screen since the browser derives height from width itself.
          aspectRatio: "85.6 / 54",
          boxShadow: "0 0 0 9999px rgba(0,0,0,0.55)",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 265 155"
          fill="none"
          preserveAspectRatio="xMidYMid meet"
        >
          {guideContent}
        </svg>
        <div className="absolute inset-0">
          <CornerBrackets isOk={isOk} />
        </div>
      </div>
    </div>
  );
};

export default IdFrame;
